/**
 * Created by MateuszWaligora on 14.07.2017.
 */
import * as shortid  from 'shortid';

/**
 * @module Store/view
 * @description Module for products
 */

/**
 * @constant State of orders store
 * @type {object}
 * */
const state = {
    sidebarOpenFlag: true,
    loadingState: false,
    alerts: [],
    confirmationModal: {
        callback: () => {},
        data: {},
        question: '',
        shouldGoToPrevPage: true
    },
    confirmationModalVisible: false,
    informationModalVisible: false,
    informationModal: {
        callback: () => {},
        data: {},
        question: '',
        shouldGoToPrevPage: true
    },
};

/**
 * @constant Getters
 * @type {object}
 * */
const getters = {
    getSidebarOpenFlag: state => state.sidebarOpenFlag,
    getLoadingState: state => state.loadingState,
    getAlerts: state => state.alerts,
    getConfirmationModal: state => state.confirmationModal,
    isConfirmationModalVisible: state => state.confirmationModalVisible,
    getInformationModal: state => state.informationModal,
    isInformationModalVisible: state => state.informationModalVisible,
    shouldGoToPrevPage: state => state.confirmationModal.shouldGoToPrevPage
};

/**
 * @constant Mutations
 * @type {object}
 * */
const mutations = {
    updateSidebarOpenFlag: (state, payload) => state.sidebarOpenFlag = payload,
    updateLoadingState: (state, payload) => state.loadingState = payload,
    addAlert: (state, payload) => {
        state.alerts.push({...payload, id: shortid.generate()});
    },
    removeAlert: (state, payload) => {
        state.alerts.splice(state.alerts.indexOf(payload), 1);
    },
    wipeAlerts: (state) => state.alerts = [],
    setConfirmationModal: (state, payload) => {
        payload.callback();
        // console.log('setConfirmationModal', payload);
        state.confirmationModal = payload
    },
    setInformationModal: (state, payload) => {
        payload.callback();
        // console.log('setConfirmationModal', payload);
        state.informationModal = payload
    },
    toggleConfirmationModal: (state, payload) => state.confirmationModalVisible = payload,
    toggleInformationModal: (state, payload) => state.informationModalVisible = payload,
    shouldGoToPrevPageMutation: (state, payload) => state.confirmationModal.shouldGoToPrevPage = payload
};

/**
 * @constant Actions
 * @type {object}

 * */
const actions = {
    async confirmAction ({commit}, payload) {
        return new Promise((resolve) => {
            commit('setConfirmationModal', payload);
            commit('toggleConfirmationModal', true);
            resolve(true);
        });
    },
    async informationAction ({commit}, payload) {
        return new Promise((resolve) => {
            commit('setInformationModal', payload);
            commit('toggleInformationModal', true);
            resolve(true);
        });
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
